import { Campaign } from "../models";

export const PERIODS = [
    'WTD',
    'MTD',
    'YTD',
    'Custom'
]

export const Frequencies = [
    'Yearly',
    'Monthly',
    'Weekly',
    'Daily'
];

export const AllowedFrequnciesByPeriod = {
    YTD: ['Monthly','Weekly'],
    MTD: ['Weekly','Daily'],
    WTD: ['Daily']
}

export const Graphs =
{
    GrossProduction: 1,
    NetProduction: 2,
    Production_Service: 3,
    Production_Visit: 4,
    Production_ProcedureCategory: 5,
    ProductionByProviderTypes: 6,
    MonthAvgProduction: 7,
    Production_PerDay: 8,
    Production_byTreatment: 9,
    OrthoProduction_PerDay: 10,
    NextMonthCurrentProduction: 11,
    PerioProduction_PerDay: 12,
    HygieneProduction_PerDay: 13,
    ProviderProduction_PerDay: 14,
    FreeForServiceVSInsuranceProduction: 15,
    DoctorProductionVSHygieneProduction: 16,
    Collection: 17,
    Collection_Service: 18,
    Collection_Visit: 19,
    Collection_byCarrier: 20,
    TotalAR: 21,
    ARBreakdown: 22,
    ARAbove90d: 23,
    TotalClaims: 24,
    ActiveClaims: 25,
    CompletedClaims: 26,
    ClaimsOver30d: 27,
    Adjustment_byProcedureType: 28,
    Adjustment_byProvider: 29,
    TotalAdjustment: 30,
    Revenue: 31,
    OutstandingBalance: 32,
    Profit: 33,
    TotalVisits: 34,
    ActivePatients: 35,
    NewPatientsAdded: 36,
    NewPatients_byReferralSource: 37,
    PatientsActivated: 38,
    CaseAcceptanceRateDollarPercent: 39,
    CaseAcceptanceRatePercent: 40,
    RetentionRate: 41,
    RecallEffectivenessRate: 42,
    RecareEffectivenessRate: 43,
    ShortNoticeCancel: 44,
    BrokenAppointment: 45,
    CancelledAppointment: 46,
    ConfirmedAppointment: 47,
    CompletedAppointment: 48,
    PerioPercentage: 49,
    NetCollections: 50,
    CollectionByProviderTypes: 51,
    CollectionByProvier: 52,
    ProductionByProvider: 53,
    CCPaymentTrends: 54,
    OverallTrends: 55,
    CampaignByStatus: 56,
    CollectionByMethod: 57
}

export const GraphCategories = {
    Financial: 1,
    Operational: 2,
    MorningHuddle: 3
}

export const GraphType = {
    Bar: 1,
    Doughnut: 2,
    Histogram: 3,
    HorizontalBar: 4,
    Line: 5,
    Pie: 6,
    Stacked: 7,
    TreeMap: 8,
    VerticalBar: 9
}